import { useMemo } from 'react';
import { useMonteCarloQuery } from '../../../../../../api/useMonteCarloQuery';
import { AsyncComponentHookResult } from '../../../../../../../../Types/ComponentHookResult';
import { PieChartSeries } from '../../../../../../../../CommonComponents/OPL/charts/PieChart/PieChart';
import { theme } from '../../../../../../../../theme/theme';

interface Header {
  probabilityOfFailure: number;
  probabilityOfSuccess: number;
  chartSeries: PieChartSeries;
  trialsCount: number;
}

export const useHeader = (): AsyncComponentHookResult<Header> => {
  const queryInfo = useMonteCarloQuery();

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const { ProbabilityOfSuccess: probabilityOfSuccess } = queryInfo.data;

    const probabilityOfFailure = 1 - probabilityOfSuccess;

    return {
      probabilityOfFailure,
      probabilityOfSuccess,
      chartSeries: [
        {
          data: [
            {
              name: 'Success',
              y: probabilityOfSuccess,
              color:
                probabilityOfSuccess >= 0.7 ? theme.colors.success[600] : theme.colors.red[600],
            },
            { name: 'Failure', y: probabilityOfFailure, color: theme.colors.neutral[200] },
          ],
        },
      ],
      trialsCount: queryInfo.data.MonteCarloTrialsCount,
    };
  }, [queryInfo.data]);

  return {
    ...queryInfo,
    data,
  };
};
